export class LocalStorageKeys {
    cryptKey: string = 'C0t3x02021';
    csem: string = 'csem'
    ilog: string = 'ilog';
    ulog: string = 'ulog';

    public getScar(userCompanyId: number) {
        return `scar_${userCompanyId}`;
    }

    public getCavaliacao(userCompanyId: number) {
        return `cavaliacao_${userCompanyId}`;
    }

    public getAlreadyAccessed(userCompanyId: number) {
        return `already_accessed_${userCompanyId}`;
    }

    public getClastfeatures(userCompanyId: number) {
        return `clastfeatures_${userCompanyId}`;
    }
}
